import request from '../request'

export default {

  getTipoGravedadPotencial() {
    return request.get('tipo_gravedad_potencial')
  },

  getTiposDeteccion() {
    return request.get('tipo_deteccion')
  },

  addGravedadPotencialIncendio(data) {
    return request.post('incendio_gravedad_potencial', data)
  },

  editAlineacionesCampbell(data) {
    return request.put(`alineaciones_campbell/${data.ID_ALINEACIONES_CAMPBELL}`, data)
  }
}
